import type { SVGProps } from "react";
export interface CollectionMusicIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CollectionMusicIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CollectionMusicIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 18V9A8.126 8.126 0 0 1 9 .875h9l.115.006a1.125 1.125 0 0 1 0 2.238L18 3.125H9A5.876 5.876 0 0 0 3.124 9v9a1.125 1.125 0 0 1-2.25 0Zm16.017-8.625a2.126 2.126 0 0 1 2.233 2.123v4.399l-.002.051.002.051a2.126 2.126 0 0 1-4.239.219l-.011-.219.011-.216a2.12 2.12 0 0 1 1.99-1.902v-2.236l-3.75.625V17l-.012.217a2.125 2.125 0 0 1-4.228 0L8.875 17l.011-.217a2.124 2.124 0 0 1 1.99-1.903v-2.715c0-1.04.75-1.926 1.775-2.097l4-.666.24-.027Z"
      />
      <path
        fill={color}
        d="M20.875 9c0-1.035-.84-1.875-1.875-1.875H9c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875zm2.25 10A4.126 4.126 0 0 1 19 23.125H9A4.125 4.125 0 0 1 4.875 19V9A4.125 4.125 0 0 1 9 4.875h10A4.125 4.125 0 0 1 23.125 9z"
      />
    </svg>
  );
}
